<template>
  <div class="results-count">
    <small>Found <strong>{{ itemCount }}</strong> events</small>
  </div>
</template>


<script>
export default {
  props: {
      itemCount: {
        required: true
      }
  }
}
</script>